import React from 'react';
import './Declaration.css'; // Make sure to create a CSS file for the styling

const Declaration = () => {
    return (
        <div className="declarations">
            <p> Welcome &nbsp; To &nbsp; EMRE.PK &nbsp; | &nbsp; Where &nbsp; Fashion &nbsp; Meets &nbsp; Confidence &nbsp;</p>
        </div>
    );
}

export default Declaration;
